import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Conf as Desc } from './desk'
import { Conf as Mob } from './mob'

type Props = {
  images: TImages
}
export const Conf: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob images={images} /> : <Desc images={images} />
}
